(function() {
    'use strict';

    angular.module('app').factory('ReactAvaibilityService', ReactAvaibilityService);

    ReactAvaibilityService.$inject = [
        '$cookies',
        '$timeout',
        '$ngConfirm',
        'DistributionService',
        'AccessManagerService',
    ];

    function ReactAvaibilityService($cookies, $timeout, $ngConfirm, DistributionService, AccessManagerService) {
        var react = DistributionService.react();
        var defaults = DistributionService.defaults();

        function isOn() {
            if (!react.on) {
                return false;
            }

            if (!AccessManagerService.isAutenticated()) {
                return false;
            }

            if (react['no-etoll-limitation'] && AccessManagerService.hasPuescLimitation()) {
                return false;
            }

            if (react['only-web'] && isPWA()) {
                return false;
            }

            return true;
        }

        function doesCookieExists() {
            return $cookies.get('react-version') !== void 0;
        }

        function isPWA() {
            return window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
        }

        function setCookie() {
            var seconds = 60 * 60 * 24 * react.expiration;

            var expires = new Date();
            expires = new Date(expires.getTime() + 1000 * seconds);

            $cookies.put('react-version', 1, {
                expires: expires,
            });
        }

        function setDefaultVersionCookie() {
            var seconds = 60 * 60 * 24 * defaults.expiration;

            var expires = new Date();
            expires = new Date(expires.getTime() + 1000 * seconds);

            $cookies.put('react-is-on', 1, {
                expires: expires,
                domain: defaults.domain
            });
        }

        function isReactDefaultVersion() {
            var cookie = $cookies.get('react-is-on');

            return cookie === '1';
        }

        function goToReact() {
            location.href = react.url;
        }

        function visit() {
            setCookie();
            setDefaultVersionCookie();

            location.href = react.url;
        }

        function close() {
            setCookie();
        }

        return {
            isOn: isOn,
            doesCookieExists: doesCookieExists,
            visit: visit,
            close: close,
            isReactDefaultVersion: isReactDefaultVersion,
            goToReact: goToReact,
        };
    }
})();
